import React from 'react'
import { Card, Form, InputNumber, Select, Row, Col, Divider, Typography } from 'antd'
import { numberOnly } from './utils'

const inputStyle = { width: 170, height: 40, fontSize: 15 }
const stretchStyle = { width: 230, height: 40, fontSize: 15 }

const CommercialConditionsCard = ({
  quoteData,
  handleQuoteChange,
  currencies,
  getTotalPaymentPercentage
}) => (
  <>
    <Row gutter={24}>
      <Col xs={24} sm={12} md={6}>
        <Form.Item label="Devise *" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
          <Select
            value={quoteData.currency}
            onChange={(v) => handleQuoteChange('currency', v)}
            style={stretchStyle}
          >
            {currencies.map((cur) => (
              <Select.Option key={cur.id} value={cur.code}>
                {cur.name} ({cur.code || cur.name})
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Form.Item label="Validité de l'offre (jours)" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
          <InputNumber
            min={1}
            value={quoteData.validity_period}
            onChange={(v) => handleQuoteChange('validity_period', v)}
            style={stretchStyle}
            onKeyDown={numberOnly}
          />
        </Form.Item>
      </Col>
    </Row>
    <Divider />
    <Typography.Title level={5}>Conditions commerciales</Typography.Title>
    <Row gutter={16}>
      <Col xs={24} sm={12} md={8}>
        <Card size="small" title="À la commande" style={{ marginBottom: 12 }}>
          <Form.Item label="Pourcentage (%)" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} style={{ marginBottom: 10 }}>
            <InputNumber
              min={0}
              max={100}
              value={quoteData.payment_at_command}
              onChange={(v) =>
                handleQuoteChange('payment_at_command', v)
              }
              style={{ ...inputStyle, width: '100%' }}
              onKeyDown={numberOnly}
            />
          </Form.Item>
          <Form.Item label="Délai de paiement (jours)" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} style={{ marginBottom: 0 }}>
            <InputNumber
              min={0}
              value={quoteData.payment_at_command_days}
              onChange={(v) =>
                handleQuoteChange('payment_at_command_days', v)
              }
              style={{ ...inputStyle, width: '100%' }}
              onKeyDown={numberOnly}
            />
          </Form.Item>
        </Card>
      </Col>
      <Col xs={24} sm={12} md={8}>
        <Card size="small" title="À la livraison" style={{ marginBottom: 12 }}>
          <Form.Item label="Pourcentage (%)" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} style={{ marginBottom: 10 }}>
            <InputNumber
              min={0}
              max={100}
              value={quoteData.payment_at_delivery}
              onChange={(v) =>
                handleQuoteChange('payment_at_delivery', v)
              }
              style={{ ...inputStyle, width: '100%' }}
              onKeyDown={numberOnly}
            />
          </Form.Item>
          <Form.Item label="Délai de paiement (jours)" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} style={{ marginBottom: 0 }}>
            <InputNumber
              min={0}
              value={quoteData.payment_at_delivery_days}
              onChange={(v) =>
                handleQuoteChange('payment_at_delivery_days', v)
              }
              style={{ ...inputStyle, width: '100%' }}
              onKeyDown={numberOnly}
            />
          </Form.Item>
        </Card>
      </Col>
      <Col xs={24} sm={12} md={8}>
        <Card size="small" title="À échéance" style={{ marginBottom: 12 }}>
          <Form.Item label="Pourcentage (%)" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} style={{ marginBottom: 10 }}>
            <InputNumber
              min={0}
              max={100}
              value={quoteData.payment_at_receipt}
              onChange={(v) =>
                handleQuoteChange('payment_at_receipt', v)
              }
              style={{ ...inputStyle, width: '100%' }}
              onKeyDown={numberOnly}
            />
          </Form.Item>
          <Form.Item label="Délai de paiement (jours)" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} style={{ marginBottom: 0 }}>
            <InputNumber
              min={0}
              value={quoteData.payment_at_receipt_days}
              onChange={(v) =>
                handleQuoteChange('payment_at_receipt_days', v)
              }
              style={{ ...inputStyle, width: '100%' }}
              onKeyDown={numberOnly}
            />
          </Form.Item>
        </Card>
      </Col>
    </Row>
	<Typography.Text
		type={getTotalPaymentPercentage() === 100 ? 'success' : 'danger'}
	>
		<span>Total pourcentage: {getTotalPaymentPercentage()}%</span>
		<span>
			{getTotalPaymentPercentage() !== 100 ? ' (Doit être exactement 100%)' : ''}
		</span>
	</Typography.Text>
  </>
)

export default CommercialConditionsCard
